import React from "react";
import { Col } from "react-bootstrap";
import TrainingRequest from "./TrainingRequest";
import "./TrainingRequestsList.css";

function TrainingRequestsList({ requests, language, role, userId }) {
  return (
    <Col className="trainings-request-list">
      {requests.map((element) => (
        <TrainingRequest
          key={element._id}
          id={element._id}
          trainingName={element.trainingName}
          trainingName_english={element.trainingName_english}
          groupName={element.groupName}
          groupName_english={element.groupName_english}
          status={element.status}
          created_at={element.created_at}
          requester={element.requester}
          requesterName={element.requesterName}
          requesterBoss={element.requesterBoss}
          language={language}
          role={role}
          userId={userId}
        />
      ))}
    </Col>
  );
}

export default TrainingRequestsList;
